import React from 'react';
import GeneralInfoServiceTracker from '../../components/GeneralInfoServiceTracker'
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'

class ProgressOverview extends React.Component {
  state = {
    totalStudents: null,
    totalProjects: null,
    totalCompleted: null,
    distribution: [],
    categoryList: []


  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.projects !== this.props.projects) {


      const { projects, totalStudents } = this.props
      let totalProjects = 0
      let totalCompleted = 0
      let investigation = 0
      let preparation = 0
      let action = 0
      let demonstration = 0
      let reflection = 0
      let projectList = []
      let directService = 0
      let indirectService = 0
      let advocacy = 0
      let research = 0
      let others = 0

      if (projects) {
        for (let key in projects) {
          if (projects.hasOwnProperty(key)) {
            for (let insideKey in projects[key]) {
              if (projects[key].hasOwnProperty(insideKey)) {
                totalProjects++
                let currentProject = projects[key][insideKey]
                if (currentProject && currentProject.status == 'inprogress' && currentProject.current_phase === 'Investigation') {
                  investigation++;
                }
                if (currentProject && currentProject.Investigation) {
                  let projectType = (currentProject.Investigation.projectType && currentProject.Investigation.projectType[0]) || currentProject.Investigation.projectType

                  switch (projectType) {
                    case 'Direct Service':
                      directService++
                      break;
                    case 'Indirect Service':
                      indirectService++
                      break;
                    case 'Advocacy':
                      advocacy++
                      break;
                    case 'Research':
                      research++
                      break;
                    default:
                      others++
                      break;
                  }
                }
                if (currentProject && currentProject.status == 'inprogress' && currentProject.current_phase === 'Preparation') {
                  preparation++;
                }
                if (currentProject && currentProject.status == 'inprogress' && currentProject.current_phase === 'Action') {
                  action++;
                }
                if (currentProject && currentProject.status == 'inprogress' && currentProject.current_phase === 'Demonstration') {
                  demonstration++;
                }
                if (currentProject && currentProject.status == 'inprogress' && currentProject.current_phase === 'Reflection') {
                  reflection++;
                }
                if (currentProject.status === 'completed') {
                  totalCompleted++
                }
                projectList.push({ 'userId': key, 'projectId': insideKey, projectDetails: currentProject })
              }
            }
          }
        }
      }

      const totalTypes = directService + indirectService + advocacy + research + others

      const directServicePercent = (100 * directService) / totalTypes
      const indirectServicePercent = (100 * indirectService) / totalTypes
      const advocacyPercent = (100 * advocacy) / totalTypes
      const researchPercent = (100 * research) / totalTypes
      const othersPercent = (100 * others) / totalTypes

      const distribution = [
        { name: 'Direct Service', value: directServicePercent, count: directService },
        { name: 'Indirect Service', value: indirectServicePercent, count: indirectService },
        { name: 'Advocacy', value: advocacyPercent, count: advocacy },
        { name: 'Research', value: researchPercent, count: research },
        { name: 'Not entered', value: othersPercent, count: others }
      ]

      let categoryList = ['Direct Service', 'Indirect Service', 'Advocacy', 'Research', 'Not entered']

      this.setState({
        totalStudents,
        totalProjects,
        distribution,
        categoryList,
        totalCompleted,
        projectList,
        investigation,
        preparation,
        action,
        demonstration,
        reflection
      })
    }
  }




  render() {

    const { totalStudents,
      totalProjects,
      distribution,
      categoryList,
      totalCompleted,
      investigation,
      preparation,
      action,
      demonstration,
      reflection } = this.state


    return (
      <GeneralInfoServiceTracker
        totalProjects={totalProjects}
        investigation={investigation}
        preparation={preparation}
        action={action}
        demonstration={demonstration}
        reflection={reflection}
        totalCompleted={totalCompleted}
        t={this.props.t}
        totalStudents={totalStudents}
        distribution={distribution}
        category={distribution}
        categoryList={categoryList}
      />
    )
  }
}

const enhancer = compose(
  translate(['view', 'nav'], { wait: true }),
  firebaseConnect((props) => {
    return [
      'users', 'projects'
    ]
  }),
  connect(
    state => {

      let totalStudents = 0
      const users = state.firebase.data.users
      const projects = state.firebase.data.projects
      const teacherSchoolId = state.firebase && state.firebase.profile.profile.school.id
      const selectedUsers = users && Object.entries(users)
        .filter(inv => inv[1].profile.school && inv[1].profile.school.id === teacherSchoolId)
        .map(inv => inv[0])


      let filteredData = {};
      projects && Object.entries(projects).filter(item => selectedUsers.indexOf(item[0]) >= 0).forEach(item => { filteredData[item[0]] = item[1] });

      const students = state.studentsOfSchool.students
      students && students.map((student, i) => {
        if (!student[1].profile.changePassword) {
          totalStudents++;
        }
      })

      return {
        users: state.firebase.data.users,
        projects: filteredData,
        students: students,
        totalStudents: totalStudents
      }
    }
  )
)
export default enhancer(ProgressOverview);



// WEBPACK FOOTER //
// ./src/containers/ProgressOverview/index.jsx